import React from 'react'

import { faUserGraduate, faUsers } from '@fortawesome/pro-regular-svg-icons'
import { faUserGraduate as faSolidUserGraduate, faUsers as faSolidUsers } from '@fortawesome/pro-solid-svg-icons'
import { Box, Typography } from '@material-ui/core'
import { get, head, isUndefined } from 'lodash'
import PropTypes from 'prop-types'

import IconRadioGroup from 'components/IconRadioGroup'

import { withContext } from './Context'
import { getDefaultSegment, getSegmentValue } from './segment-service'

export const USER_TYPE = {
  students: 'Student',
  parents: 'Parent',
}

export const USER_TYPE_DISPLAY = {
  [USER_TYPE.students]: {
    userType: USER_TYPE.students,
    label: 'Students',
  },
  [USER_TYPE.parents]: {
    userType: USER_TYPE.parents,
    label: 'Parents',
  },
}

export const DEFAULT_USER_TYPE = USER_TYPE.students

export const SegmentName = 'UserType'
export const Criteria = 'Must'

const selectUserType = (segment) => head(getSegmentValue(segment, Criteria, SegmentName))

export const getUserType = (segment) => selectUserType(segment) || DEFAULT_USER_TYPE

export const addDefaultUserTypeSegment = (segment) => {
  const x = get(segment, 'Criteria.Must', [])
  x.push({
    Name: SegmentName,
    Operation: 'in',
    Values: [DEFAULT_USER_TYPE],
  })
}

export const isMissingUserType = (segment) => isUndefined(selectUserType(segment))
export const getUserTypeDisplay = (segment) => get(USER_TYPE_DISPLAY, `[${getUserType(segment)}].label`)

export const isParent = (segment) => getUserType(segment) === USER_TYPE.parents
export const isStudent = (segment) => getUserType(segment) === USER_TYPE.students

export const UserTypeSelector = ({ segment, updateSegment, trigger }) => {
  const currentValue = getUserType(segment)
  return (
    <Box py={1}>
      <Box pb={2}>
        <Typography
          variant="subtitle2"
          color="textPrimary"
        >
          Select user
        </Typography>
      </Box>
      <IconRadioGroup
        options={[
          {
            title: USER_TYPE_DISPLAY[USER_TYPE.students].label,
            faIcon: currentValue === USER_TYPE.students ? faSolidUserGraduate : faUserGraduate,
            value: USER_TYPE.students,
            selected: currentValue === USER_TYPE.students,
          },
          {
            title: USER_TYPE_DISPLAY[USER_TYPE.parents].label,
            faIcon: currentValue === USER_TYPE.parents ? faSolidUsers : faUsers,
            value: USER_TYPE.parents,
            selected: currentValue === USER_TYPE.parents,
          },
        ]}
        onSelect={(value) => {
          const defaultSegment = getDefaultSegment(trigger, value)
          updateSegment(defaultSegment)
        }}
      />
    </Box>
  )
}

UserTypeSelector.propTypes = {
  trigger: PropTypes.string,
  segment: PropTypes.object,
  updateSegment: PropTypes.func.isRequired,
}

export default withContext(UserTypeSelector)
